import React from 'react';
import './Course.css';

interface CourseItem {
  title: string;
  institution: string;
  date: string;
  description: string;
  certificate?: string;
  skills: string[];
}

const Course: React.FC = () => {
  const courses: CourseItem[] = [
    {
      title: 'Introdução ao PHP orientado a objetos',
      institution: 'Udemy - Diego Mariano, Ph.D.',
      date: '2023',
      description: 'Curso completo de PHP com foco em programação orientada a objetos, abordando conceitos fundamentais e boas práticas de desenvolvimento.',
      skills: ['PHP', 'OOP', 'POO', 'Backend']
    },
    {
      title: 'Desenvolvimento Web com PHP e Banco de Dados MySQL',
      institution: 'Udemy - Alfahelix Treinamentos',
      date: '2023',
      description: 'Desenvolvimento de aplicações web completas utilizando PHP e MySQL, incluindo integração com banco de dados e criação de sistemas dinâmicos.',
      skills: ['PHP', 'MySQL', 'SQL', 'Web Development']
    },
    {
      title: 'Web Design: Construa Sites com PHP, HTML, CSS e JavaScript',
      institution: 'Udemy - Diego Mariano, Ph.D., Alfahelix Treinamentos',
      date: '2023',
      description: 'Curso completo de web design e desenvolvimento, cobrindo as principais tecnologias para criação de sites modernos e responsivos.',
      skills: ['PHP', 'HTML', 'CSS', 'JavaScript', 'Web Design']
    },
    {
      title: 'HTML5',
      institution: 'Udemy - Paulo Andrade, PhD',
      date: '2022',
      description: 'Introdução completa ao HTML5, cobrindo desde conceitos básicos até recursos avançados da linguagem de marcação.',
      skills: ['HTML5', 'Web Development', 'Semantic HTML']
    },
    {
      title: 'JavaScript e jQuery para Iniciantes',
      institution: 'Udemy - Diego Mariano, Ph.D.',
      date: '2022',
      description: 'Fundamentos de JavaScript e jQuery, incluindo manipulação do DOM, eventos, animações e desenvolvimento de aplicações web interativas.',
      skills: ['JavaScript', 'jQuery', 'DOM', 'Frontend']
    }
  ];

  const certifications = [
    'Introdução ao PHP orientado a objetos',
    'Desenvolvimento Web com PHP e Banco de Dados MySQL',
    'Web Design: PHP, HTML, CSS e JavaScript',
    'HTML5',
    'JavaScript e jQuery'
  ];

  return (
    <div className="course-page">
      <section className="course-hero">
        <div className="container">
          <h1 className="page-title">Cursos & Certificações</h1>
          <p className="page-subtitle">
            Minha jornada de aprendizado contínuo em tecnologia
          </p>
        </div>
      </section>

      <section className="courses-section">
        <div className="container">
          <h2 className="section-title">Cursos Concluídos</h2>
          <div className="courses-grid">
            {courses.map((course, index) => (
              <div key={index} className="course-card">
                <div className="course-header">
                  <div className="course-icon">
                    <i className="fas fa-graduation-cap"></i>
                  </div>
                  <div className="course-date">{course.date}</div>
                </div>
                <h3 className="course-title">{course.title}</h3>
                <p className="course-institution">
                  <i className="fas fa-university"></i>
                  {course.institution}
                </p>
                <p className="course-description">{course.description}</p>
                <div className="course-skills">
                  {course.skills.map((skill, idx) => (
                    <span key={idx} className="skill-tag">{skill}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="certifications-section">
        <div className="container">
          <h2 className="section-title">Certificações</h2>
          <div className="certifications-grid">
            {certifications.map((cert, index) => (
              <div key={index} className="certification-item">
                <i className="fas fa-certificate"></i>
                <span>{cert}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="education-section">
        <div className="container">
          <h2 className="section-title">Educação</h2>
          <div className="education-card">
            <div className="education-icon">
              <i className="fas fa-school"></i>
            </div>
            <div className="education-content">
              <h3>Ensino Médio Completo</h3>
              <p>Formação básica com foco em exatas e tecnologia</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Course;
